import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../../services/contexts/AuthContext';
import TenantAdminSidebar from './components/TenantAdminSidebar';
import TenantAdminDashboard from './pages/TenantAdminDashboard';
import QuestionManagement from './pages/QuestionManagement';
import UserManagement from './pages/UserManagement';
import PatientManagement from './pages/PatientManagement';
import AnalyticsReports from './pages/AnalyticsReports';
import OrganizationSettings from './pages/OrganizationSettings';
import OrganizationProfile from './pages/OrganizationProfile';
import { LogOut } from 'lucide-react';
import { tenantAdminAPI } from '../../services/api/tenantAdminAPI';

const TenantAdminApp = () => {
  const { user, logout } = useAuth();
  const [activeView, setActiveView] = useState('dashboard');
  const [tenantInfo, setTenantInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleLogout = () => {
    logout();
  };

  useEffect(() => {
    const loadTenantInfo = async () => {
      if (user) {
        try {
          const response = await tenantAdminAPI.getTenantInfo();
          setTenantInfo(response.data);
        } catch (error) {
          console.error('Failed to load tenant info:', error);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    loadTenantInfo();
  }, [user]);

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Tenant Admin Sidebar */}
      <TenantAdminSidebar activeView={activeView} setActiveView={setActiveView} />
      
      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Navigation Bar */}
        <header className="bg-white shadow-sm border-b border-gray-200">
          <div className="flex items-center justify-between px-6 py-4">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">
                {tenantInfo?.name || 'Loading...'} Admin
              </h1>
              {/* <p className="text-sm text-gray-600">Manage your organization and team</p> */}
            </div>
            <div className="flex items-center space-x-4">
              {/* <div className="text-right">
                <p className="text-sm font-medium text-gray-900">{user?.name}</p>
                <p className="text-xs text-gray-500">Organization Administrator</p>
              </div> */}
              <button
                onClick={handleLogout}
                className="flex items-center space-x-2 px-4 py-2 text-sm text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <LogOut className="h-4 w-4" />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </header>

        {/* Content Area */}
        <main className="flex-1 overflow-auto p-6">
          <Routes>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<TenantAdminDashboard />} />
            <Route path="questions" element={<QuestionManagement />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="patients" element={<PatientManagement />} />
            <Route path="analytics" element={<AnalyticsReports />} />
            <Route path="settings" element={<OrganizationSettings />} />
            <Route path="profile" element={<OrganizationProfile />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default TenantAdminApp;
